import { CommentState } from "./comment.type";

export const initialState: CommentState = {
  comments: {},
  replies: {},
  pagination: {},
  replyLoading: {},
  replyPagination: {},
  sort: 'most_recent',
}
